export const refreshStateMenuItems = [
  { title: 'Off', time: 0 },
  { title: 'Every 10 seconds', time: 10000 },
  { title: 'Every 1 minute', time: 60000 },
  { title: 'Every 2 minutes', time: 120000 },
  { title: 'Every 5 minutes', time: 300000 },
  { title: 'Every 15 minutes', time: 900000 },
];
